<template>
  <div
    ref="mapContainer"
    class="tianditu-fire-map"
  />
</template>

<script>
import {
  bindTiandituTileRetry,
  clearTiandituMapLayers,
  destroyTiandituMap,
  loadTiandituMap
} from '@/utils/tiandituMapLoader';
import { convertToTianditu } from '@/utils/mapCoordinate';

// 默认中心来自原百度地图固定点，不能跟随后端业务坐标配置改变来源。
const DEFAULT_CENTER = { lng: 113.351585, lat: 23.107915, coordinateSystem: 'BD09' };

export default {
  name: 'TiandituFireMap',
  props: {
    lng: {
      type: [Number, String],
      default: null
    },
    lat: {
      type: [Number, String],
      default: null
    },
    zoom: {
      type: Number,
      default: 14
    }
  },
  data () {
    return {
      map: null,
      mapReady: false,
      marker: null,
      unbindTileRetry: null
    };
  },
  computed: {
    coordinateKey () {
      return `${this.lng || ''},${this.lat || ''}`;
    }
  },
  methods: {
    renderMarker () {
      if (!this.mapReady || !this.map) return;
      clearTiandituMapLayers(this.map);
      this.marker = null;
      const converted = convertToTianditu({ lng: this.lng, lat: this.lat });
      if (!converted) return;
      const point = new window.T.LngLat(converted.lng, converted.lat);
      if (typeof this.map.centerAndZoom === 'function') {
        this.map.centerAndZoom(point, this.zoom);
      } else {
        if (typeof this.map.panTo === 'function') this.map.panTo(point);
        if (typeof this.map.setZoom === 'function') this.map.setZoom(this.zoom);
      }
      this.marker = new window.T.Marker(point);
      this.map.addLayer(this.marker);
    }
  },
  watch: {
    coordinateKey () {
      this.renderMarker();
    }
  },
  async mounted () {
    try {
      await loadTiandituMap();
      if (this._isBeingDestroyed) return;
      const api = window.T;
      this.map = new api.Map(this.$refs.mapContainer);
      const center = convertToTianditu(DEFAULT_CENTER, DEFAULT_CENTER.coordinateSystem);
      this.map.centerAndZoom(new api.LngLat(center.lng, center.lat), this.zoom);
      this.map.enableScrollWheelZoom(true);
      this.map.setStyle('indigo');
      this.unbindTileRetry = bindTiandituTileRetry(this.$refs.mapContainer, detail => {
        this.$emit('map-error', new Error(`天地图瓦片重试失败: ${detail.src}`));
      });
      this.mapReady = true;
      this.renderMarker();
    } catch (error) {
      this.$emit('map-error', error);
    }
  },
  beforeDestroy () {
    destroyTiandituMap(this.map);
    if (this.unbindTileRetry) this.unbindTileRetry();
    this.unbindTileRetry = null;
    this.map = null;
    this.mapReady = false;
    this.marker = null;
  }
};
</script>

<style lang="scss">
.tianditu-fire-map {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #131124;
}
</style>
